/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import axios from 'axios'
import {
    CATEGORY_REQUEST, CATEGORY_SUCCESS, CATEGORY_FAILURE,
    CURRENT_CATEGORY_REQUEST, CURRENT_CATEGORY_SUCCESS, CURRENT_CATEGORY_FAILURE,
} from '../reducers/category'

function categoryDataAPI(idx) {
    const url = `/front/v3/item/cate?idx_b_manager=${idx}`
    return axios.post(url)
}

function* categoryData(action) {
    try {
        const result = yield call(categoryDataAPI, action.data)
        if (!result.data.success) {
            throw new Error('categoryDataAPI error')
        }
        yield put({
            type: CATEGORY_SUCCESS,
            data: result.data.result.cate,
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: CATEGORY_FAILURE,
            data: []
        })
    }
}

function currentCategoryAPI(cate) {
    const url = `/front/v3/item/cate/${cate}`
    return axios.post(url)
}

function* currentCategory(action) {
    try {
        const result = yield call(currentCategoryAPI, action.data)
        yield put({
            type: CURRENT_CATEGORY_SUCCESS,
            data: result.data.result,
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: CURRENT_CATEGORY_FAILURE,
            data: null
        })
    }
}

// cate all
function* watchCategoryData() {
    yield takeLatest(CATEGORY_REQUEST, categoryData)
}

// current cate
function* watchCurrentCategory() {
    yield takeLatest(CURRENT_CATEGORY_REQUEST, currentCategory)
}

export default function* categorySaga() {
    yield all([fork(watchCategoryData)])
    yield all([fork(watchCurrentCategory)])
}



// WEBPACK FOOTER //
// ./src/estimate_list/sagas/category.js